import type { App } from 'vue';
import { IonicVue, isPlatform } from '@ionic/vue';
import '@ionic/vue/css/core.css';

//  =====================ionic 开始==========================

/* Core CSS required for Ionic components to work properly */
// import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
// import "@ionic/vue/css/normalize.css";
// import "@ionic/vue/css/structure.css";
// import "@ionic/vue/css/typography.css";

// /* Optional CSS utils that can be commented out */
// import "@ionic/vue/css/padding.css";
// import "@ionic/vue/css/float-elements.css";
// import "@ionic/vue/css/text-alignment.css";
// import "@ionic/vue/css/text-transformation.css";
// import "@ionic/vue/css/flex-utils.css";
// import "@ionic/vue/css/display.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* @import '@ionic/vue/css/palettes/dark.always.css'; */
/* @import '@ionic/vue/css/palettes/dark.class.css'; */
// import "@ionic/vue/css/palettes/dark.system.css";

//  =====================ionic 结束==========================

/** 挂载ionic */
export default function setupIonic(app: App) {
  app.use(IonicVue, {
    mode: isPlatform('ios') || isPlatform('iphone') ? 'ios' : 'md',
    swipeBackEnabled: false, // ios下，返回手势失效
    animated: false, // 页面切换无动画
  });
}
